import Map from '../../components/Map';
import CategoryIcon from '../../assets/category.svg';
import FestivalIcon from '../../assets/masks-theater.svg';
import MediumIcon from '../../assets/MediumIcon.svg';
import VenueIcon from '../../assets/VenueIcon.svg';
import { AddToCalendarButton } from 'add-to-calendar-button-react';
import { mapEventToImage, importAll } from '../../constants';
import { useNavigate } from 'react-router-dom';

export default function MobileDetailPage({ event }) {   
    window.scrollTo({ top: 0, left: 0})   
    const images = importAll(require.context('../../assets/eventImages', false, /\.(png|jpe?g|svg)$/));
    const imageKey = mapEventToImage[event.id];
      
    console.log(event);
    const date = new Date(event.start_time);
    const endTimeDate = new Date(event.end_time);
    const options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric', 
        minute: '2-digit'
    };
    const optionsTime = {
        hourCycle: 'h24'
    }
    const dateTimeString = date.toLocaleTimeString('en-US', options);
    const eventDate = event.start_time.split('').splice(0, 10).join('');
    const eventAddress = `${event.venues[0].address_street}, ${event.venues[0].address_city} ${event.venues[0].address_state}`;

    const onClick = () => {
        window.open(event.event_link, '_blank');
    };

    const navigate = useNavigate();
    const onBack = () => {
        navigate(-1);
    }

    let price = '';
    if (event.ticket_price_min && event.ticket_price_max) {
        if (event.ticket_price_min === event.ticket_price_max) {
            price = `$${event.ticket_price_min}`
        } else {
            price = `$${event.ticket_price_min} - $${event.ticket_price_max}`
        }    
    } else if (event.ticket_price_min) {
        price = `$${event.ticket_price_min}`
    } else {
        price = `$${event.ticket_price_max}`
    }
    if (price === '$0') {
        price = 'FREE'
    }

    return (
        <div className="container bg-white">
            <div className="row">
                <div className="col align-self-start">
                    <button type="button" className="btn" onClick={onBack}>
                        <i className="fa fa-arrow-left" aria-hidden="true"></i>
                    </button>
                </div>
            </div>
            <div className="row my-3">
                <div>
                    {event.category.map(category => {
                        return (
                            <span key={category.id} id="white" style={{marginRight: 8}}>{category.name.toUpperCase()}</span>
                        );
                    })}
                    <h1>{event.name}</h1>
                    <h6>{dateTimeString}</h6>
                    <p>{price}</p>
                </div>
            </div>
            <img src={images[imageKey]} className="mx-auto d-block img-fluid" alt="..." />
            <div className='row my-3'>
                <div className='col-12 col-md-6'>
                    <div>
                        <div className='row'>
                            <div className='col-6'>
                                <div className='row'>
                                    <div className='col-2'>
                                        <img src={VenueIcon} alt='venue icon'></img>
                                    </div>
                                    <div className='col text-start'>
                                        <h6 className="no-margin">Venue</h6>
                                        <small>{event.venues[0].name}</small>
                                        <br/><small>{eventAddress}</small>
                                    </div>
                                </div>
                            </div>
                            <div className='col-6'>
                                <div className='row'>
                                    <div className='col-2'>
                                        <img src={CategoryIcon} alt='category icon'></img>
                                    </div>
                                    <div className='col text-start'>
                                        <h6 className="no-margin">Category</h6>
                                        <div>{event.category.map((cat) => {return (<small key={cat.name}>{`${cat.name.charAt(0).toUpperCase()+cat.name.slice(1)} `}</small>)})}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row pt-3'>
                        <div className='col-6'>
                                <div className='row'>
                                    <div className='col-2'>
                                        <img src={FestivalIcon} alt='venue icon'></img>
                                    </div>
                                    <div className='col text-start'>
                                        <h6 className="no-margin">Festival / Affiliation</h6>
                                        <small>{event.festival_affiliation}</small>
                                    </div>
                                </div>
                            </div>
                            <div className='col-6'>
                                <div className='row'>
                                    <div className='col-2'>
                                        <img src={MediumIcon} alt='category icon'></img>
                                    </div>
                                    <div className='col text-start'>
                                        <h6 className="no-margin">Medium</h6>
                                        <div>{event.medium.map((med) => {return (<small key={med.id}>{`${med.name.charAt(0).toUpperCase()+med.name.slice(1)} `}</small>)})}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr className="hr" />
                    <h5>About the event</h5>
                    <p>{event.description}</p>
                </div>
            </div>
            <div className='row'>
                <hr className="hr my-3"/>
                <h3 className="my-3">Where you'll be</h3>
                <Map events={[event]} zoom={15} height={"50vh"} className="my-3"/>
                <h5 className="mt-3">Accessibility info</h5>
                <p className='mb-3'>{event.venues[0].accessibility_info}</p>
            </div>

            <div className='row mb-2 sticky-bottom bg-white border text-center no-gutter'>
                <div className='row align-items-center'>
                    <div className='col mb-3'>
                    <AddToCalendarButton
                        className="share-to-calendar"
                        name={event.name}
                        startDate={eventDate}
                        startTime={date.toLocaleTimeString('en-US', optionsTime)}
                        endTime={endTimeDate.toLocaleTimeString('en-US', optionsTime)}
                        timeZone="America/Los_Angeles"
                        location={eventAddress}
                        description={event.description}
                        options="'Apple','Google','iCal','Outlook.com'"
                        label="Add to Calendar"
                        inline
                        listStyle="dropup-static"
                        lightMode="light"
                        styleLight="--btn-background: #000000; --btn-text: #ffff; --font: 'Inter', sans-serif;"
                    ></AddToCalendarButton>
                    </div>
                    <div className='col mb-3'>
                        <button type="button" className="btn btn-outline-dark" onClick={onClick}>Learn More</button>
                    </div>
                </div>                
            </div>
        </div>
    );
}